// extracted by mini-css-extract-plugin
export default {"loading":"LoadingIcons_loading__RTiA-"};